import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconArrowRight = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.78906 5.96094C9.09375 6.26562 9.09375 6.73438 8.78906 7.03906L5.03906 10.7891C4.75781 11.0703 4.26562 11.0703 3.98438 10.7891C3.67969 10.4844 3.67969 10.0156 3.98438 9.71094L7.19531 6.5L3.98438 3.28906C3.67969 2.98438 3.67969 2.51562 3.98438 2.21094C4.26562 1.92969 4.75781 1.92969 5.03906 2.21094L8.78906 5.96094Z",
		fill: "currentColor"
	})
});
export default SvgIconArrowRight;
